import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okList, okResults, okSingle } from '@/mock/mock.response.util';
import { BUTTON_STATUS_DROPDOWN_FIXTURES, EMAIL_TEMPLATE_DROPDOWN_FIXTURES, HOST_RESPOND_DROPDOWN_FIXTURES, SETUP_WORKFLOW_FIXTURES, TOTAL_LEVEL_WORKFLOW_DROPDOWN_FIXTURES } from '@/mock/setup-workflow/setup-workflow.fixtures';

const ID_ROUTE = /\/setup-workflow\/([^/?]+)$/;

export const setupWorkflowHandler: IMockHandler = {
    matches(req: any) {
        // Exclude assets/i18n files (translation files)
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        const matches = req.url.includes('/setup-workflow') ||
            req.url.includes('/total-level-workflow/dropdown') ||
            req.url.includes('/button-status/dropdown') ||
            req.url.includes('/email-template/dropdown') ||
            req.url.includes('/host-respond/dropdown');

        console.log('[SetupWorkflowHandler.matches] Returning:', matches);
        return matches;
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── Dropdowns first (most specific) ──────────────────────
        if (url.includes('/total-level-workflow/dropdown')) return okResults(TOTAL_LEVEL_WORKFLOW_DROPDOWN_FIXTURES);
        if (url.includes('/button-status/dropdown')) return okResults(BUTTON_STATUS_DROPDOWN_FIXTURES);
        if (url.includes('/email-template/dropdown'))         return okResults(EMAIL_TEMPLATE_DROPDOWN_FIXTURES);
        if (url.includes('/host-respond/dropdown'))     return okResults(HOST_RESPOND_DROPDOWN_FIXTURES);

        // ── GET /setup-workflow/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = SETUP_WORKFLOW_FIXTURES.find(u => String(u.id) === idMatch[1]);
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /setup-workflow ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/setup-workflow')) {
            const page = Number(req.params.get('page') ?? 0);
            const size = Number(req.params.get('size') ?? 10);
            return okList(SETUP_WORKFLOW_FIXTURES, page, size);
        }

        // ── POST /setup-workflow ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/setup-workflow'))
            return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /setup-workflow/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            const base = SETUP_WORKFLOW_FIXTURES.find(u => String(u.id) === idMatch[1]);
            return okSingle({ ...base, ...req.body });
        }

        // ── DELETE /setup-workflow/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        throw new Error(`[SetupWorkflowHandler] unhandled: ${method} ${url}`);
    }
};
